function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.118 2.854C6.178 1.819 6.998 1 8 1c1.003 0 1.823.82 1.882 1.854 1.618.754 2.747 2.453 2.747 4.428V9.55c0 .244.092.478.257.65l.963 1.009a.557.557 0 01.112.587.515.515 0 01-.475.332H10.57v.18C10.571 13.795 9.421 15 8 15c-1.42 0-2.571-1.205-2.571-2.692v-.18H2.514a.515.515 0 01-.475-.332.557.557 0 01.112-.587l.963-1.009a.942.942 0 00.257-.65V7.282c0-1.975 1.13-3.674 2.747-4.428zm.34 9.274v.18c0 .892.69 1.615 1.542 1.615.852 0 1.543-.723 1.543-1.615v-.18H6.457zM8 2.077c-.473 0-.857.402-.857.897v.245a.538.538 0 01-.343.508c-1.399.518-2.4 1.915-2.4 3.555V9.55c0 .53-.201 1.037-.559 1.412l-.085.09h8.488l-.085-.09A2.046 2.046 0 0111.6 9.55V7.282c0-1.64-1.001-3.037-2.4-3.555a.538.538 0 01-.343-.508v-.245c0-.495-.384-.897-.857-.897z",
  fill: "#2D2D2D"
});
function SvgCampana(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Campana.svg";
export { SvgCampana as ReactComponent };